import React from 'react';

// Common components
import MobileLinks from '../common/MobileLinks/MobileLinks';

// Container components
import ResultContainer from './ResultContainer/ResultContainer';

/**
 * This function renders the SearchResult component page and its components.
 */
export default function SearchResult() {
  return (
    <div>
      <ResultContainer />
      <MobileLinks />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Result/index.js